<div class="wrapper">
  <div class="container">
    <p>Logging out the user...</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
